// Required environment variables
const requiredEnvVars = {
  // Firebase Configuration
  VITE_FIREBASE_API_KEY: '',
  VITE_FIREBASE_AUTH_DOMAIN: '',
  VITE_FIREBASE_PROJECT_ID: '',
  VITE_FIREBASE_STORAGE_BUCKET: '',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '',
  VITE_FIREBASE_APP_ID: '',

  // Supabase Configuration
  VITE_SUPABASE_URL: '',
  VITE_SUPABASE_ANON_KEY: '',

  // OpenAI Configuration
  VITE_OPENAI_API_KEY: '',

  // Razorpay Configuration
  VITE_RAZORPAY_KEY_ID: '',
  VITE_RAZORPAY_KEY_SECRET: '',
  
  // Google Analytics
  VITE_GA_MEASUREMENT_ID: ''
};

// Helper function to get environment variables with validation
export function getEnvVar(key: keyof typeof requiredEnvVars): string {
  const value = import.meta.env[key];
  
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}\nPlease check your .env file and ensure all required variables are set.`);
  }
  
  return value;
}

// Export all environment variables
export const env = {
  firebase: {
    apiKey: getEnvVar('VITE_FIREBASE_API_KEY'),
    authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnvVar('VITE_FIREBASE_APP_ID')
  },
  supabase: {
    url: getEnvVar('VITE_SUPABASE_URL'),
    anonKey: getEnvVar('VITE_SUPABASE_ANON_KEY')
  },
  openai: {
    apiKey: getEnvVar('VITE_OPENAI_API_KEY')
  },
  razorpay: {
    keyId: getEnvVar('VITE_RAZORPAY_KEY_ID'),
    keySecret: getEnvVar('VITE_RAZORPAY_KEY_SECRET')
  },
  analytics: {
    measurementId: getEnvVar('VITE_GA_MEASUREMENT_ID')
  }
};